module.exports = __webpack_public_path__ + "react/fonts/radio-fail.d44eb6dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/radio-fail.svg
// module id = 1212
// module chunks = 0